import Sidebar from "../components/sidebar";
import Login from "../components/login";
import Navbar from "../components/navbar";
import Register from "../components/register";
import Profile from "../components/profile";

function ProfilPage() {
  return (
    <>
      <Sidebar>
        <Profile />
      </Sidebar>
    </>
  );
}
export default ProfilPage;
